import React, { useEffect } from 'react';
import { coach } from './config/coach';
import LandingPage from './pages/LandingPage';

const setMetaTag = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
};

function App() {
  useEffect(() => {
    document.title = coach.pageTitle;
    setMetaTag('name', 'description', coach.metaDescription);
    setMetaTag('property', 'og:title', coach.og.title);
    setMetaTag('property', 'og:description', coach.og.description);
    setMetaTag('property', 'og:type', 'website');
  }, []);

  return <LandingPage />;
}

export default App;
